import axios from 'axios';

export default () =>
  new Promise((resolve, reject) => {
    axios
      .get(process.env.VUE_APP_API_ADMIN_LOCATION + 'users/country-stats')
      .then(({ data }) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
